var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-expand-transition',[(_vm.showParagraph)?_c('div',{staticStyle:{"padding":"10px 0 10px 0"},attrs:{"id":_vm.sectionElId(_vm.section)},domProps:{"innerHTML":_vm._s(_vm.displayText)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }